/* 指定日より後の日付を表示するカレンダー */
import React from 'react';
import RowTemplate from '../atoms/RowTemplate';
import DatePicker from './DatePicker';
import Messages from '../molecules/Messages';
import Paragraph from '../atoms/Paragraph';
var AfterSpecifiedDate = function (_a) {
    var id = _a.id, label = _a.label, need = _a.need, value = _a.value, message = _a.message, name = _a.name, placeholder = _a.placeholder, help_msg = _a.help_msg, disabled = _a.disabled, handleChange = _a.handleChange, handleBlur = _a.handleBlur, minDate = _a.minDate;
    var returnStringDateJp = function () {
        if (value !== null && typeof value !== 'undefined') {
            var year = value.getFullYear();
            var month = value.getMonth() + 1;
            var date = value.getDate();
            return year + "\u5E74" + month + "\u6708" + date + "\u65E5";
        }
        return '';
    };
    return (React.createElement(RowTemplate, { label: label, need: need, disabled: disabled, content: disabled ? (React.createElement(Paragraph, { label: returnStringDateJp() })) : (React.createElement(React.Fragment, null,
            React.createElement(DatePicker, { id: id, className: "form-control", placeholder: placeholder, name: name, handleChangeDate: handleChange, selected: value, disabled: disabled, handleBlur: handleBlur, minDate: minDate }),
            React.createElement(Messages, { help_msg: help_msg, valid_msg: message }))) }));
};
export default AfterSpecifiedDate;
